<ng-container *ngIf="!isNewEDPScoreboard">
    <ms-favourite-participant-toggle class="participant-favourite" [participant]="participant" [sport]="event.sport.id" [source]="event.offerSource">
    </ms-favourite-participant-toggle>
</ng-container>
<div class="participant-name">
    <div
        [ngClass]="{
            'participant-record-picther': isNewEDPScoreboard && (isPitcherOrRecordsAvailable || !!participantInfo?.rank || participant.country),
        }">
        <ng-container *ngIf="!isNewEDPScoreboard || !isDoubleParticipant; else doubleParticipantNames">
            <div class="participant-name-value" [ngClass]="{ short: vm.logoIsLoaded, truncate: vm.shouldTruncateParticipantName, rank: isShowRank }">
                <span class="participant-record" *ngIf="isNewEDPScoreboard && !!participantInfo?.rank"> {{ participantInfo?.rank }}</span>
                {{ vm.participantName }}
                <span class="participant-country" *ngIf="participant.country && !isNewEDPScoreboard"> {{ getParticipantCountry() }}</span>
                <span class="away-indicator away-indicator-inline" *ngIf="showAwayIndicator" [msAutomation]="'scoreboard-away-indicator'">{{
                    sitecore.globalMessages.AwayIndicator
                }}</span>
                <div class="away-indicator away-indicator-stand-alone" *ngIf="showAwayIndicator" [msAutomation]="'scoreboard-away-indicator'">
                    {{ sitecore.globalMessages.AwayIndicator }}
                </div>
            </div>
        </ng-container>

        <span class="participant-country" *ngIf="participant.country && showCountryName && isNewEDPScoreboard"> {{ getParticipantCountry() }}</span>

        <span class="participant-record" *ngIf="isNewEDPScoreboard && !!participantInfo?.winLossStats"> {{ participantInfo?.winLossStats }}</span>

        <span class="participant-record" *ngIf="isNewEDPScoreboard && !!participantInfo?.pitcher"> {{ participantInfo?.pitcher }}</span>
    </div>

    <div class="participant-logo-container" *ngIf="showIndicator && vm.participantLogoUrl" [hidden]="!vm.logoIsLoaded">
        <img class="participant-logo" src="{{ vm.participantLogoUrl }}" (load)="logoLoad()" />
    </div>
</div>

<ng-template #doubleParticipantNames>
    <ng-container *ngFor="let name of doubleParticipantName; let i = index">
        <div class="participant-name-value" [ngClass]="{ short: vm.logoIsLoaded, truncate: vm.shouldTruncateParticipantName }">
            {{ name }}
        </div>
    </ng-container>
</ng-template>
